import React from 'react';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import tImg1 from '../../images/testimonials/img-1.jpg'
import testimonials from '../../data/testimonials.json';


const settings = {
    dots: true,
    arrows: false,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
};


const Testimonial = (props) => {

    return (
        <section className={`testimonials-section section-padding ${props.tClass}`}>
            <div className="container">
                <div className="row">
                    <div className="col col-lg-4 col-12">
                        <div className="section-title-s2">
                            <h2>Here are some of our happy clients!</h2>
                        </div>
                    </div>
                    <div className="col col-lg-8 col-12">
                        <div className="testimonial-grids testimonials-slider">
                            <Slider {...settings}>
                                {testimonials.map((item) => (
                                    <div className="grid" key={item.id}>
                                        <div className="quote">
                                            <p>{item.quote}</p>
                                        </div>
                                        <div className="details">
                                            <div className="img-holder">
                                                <img src={tImg1} alt="" />
                                            </div>
                                            <h5>{item.name}</h5>
                                            <span>{item.title}</span>
                                        </div>
                                    </div>
                                ))}
                            </Slider>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default Testimonial;
